import React, { useRef, useState } from "react";
import "./ProfileComponent.css";
import AddressDetails from "../AddressDetails/AddressDetails";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { Apiurl } from "../../Pages/utils/page";
import { ClipLoader } from "react-spinners";
import { Modal } from "react-bootstrap";
const ProfileComponent = ({
  formData,
  setFormData,
  profileData,
  setEditData,
  editData,
  setBuisnessCheck,
  buisnessCheck,
  businessDetail,
  setBusinessDetail,
  handleMoveToBusiness,
  vendorBannerAnalytic,
  setBannerUrl,
  showSaveButton,
  setShowSaveButton,
  updateIndex,
  setUpdateIndex,
  setHideButton,
  hideButton,
  setAddress,
  Address,
  handleAddAddress,
  handleClose,
  handleShow,
  show,
  DeliveryAddressList,
  handleRemoveDeliveryAddress,
  handleEditaddress,
  PrefiledData,
  UpdateDefaultDeliveryAddress,
  handleEditProfile,
  BannerAdd,
  setCroppedImage,
  profileImage,
  setProfileImage,
  bannerImageData,
  setImage,
  setBannerUpdate,
  bannerUpdate,
  image,
  fileBannerRef,
  loading,
  setShowUpdate,
  showUpdate,
  handleCloseBanner,
  profileImageRed,
  imageUrl,
  FetchGoogleImage,
  UpdateUserProfile,
  setBannerUpdateImage,
  setClickedBannerData,
  clickedBannerData,
  handleUpdateBannerImage,
}) => {
  const fileInputRef = useRef(null);
  // const [croppedImage, setCroppedImage] = useState(null);
  const cropperRef = useRef(null);
  const cropperRefBanner = useRef(null);
  const cropperProfileRef = useRef(null);
  const onCrop = () => {
    const imageElement = cropperRef.current;
    const cropper = imageElement?.cropper;
    const croppedCanvas = cropper.getCroppedCanvas({
      backgroundColor: "#ffffff",
    });
    const base64Image = croppedCanvas.toDataURL();
    const cleanedUrl = base64Image.split(",")[1];
    setCroppedImage(cleanedUrl);
  };
  const onUpdateBannerCrop = () => {
    const imageElement = cropperRefBanner.current;
    const cropper = imageElement?.cropper;
    const croppedCanvas = cropper.getCroppedCanvas({
      backgroundColor: "#ffffff",
    });
    const base64Image = croppedCanvas.toDataURL();
    const cleanedUrl = base64Image.split(",")[1];
    setBannerUpdateImage(cleanedUrl);
  };
  const onProfileCrop = () => {
    const imageElement = cropperProfileRef.current;
    const cropper = imageElement?.cropper;
    const croppedCanvas = cropper.getCroppedCanvas({
      backgroundColor: "#ffffff",
    });
    const base64Image = croppedCanvas.toDataURL();
    const cleanedUrl = base64Image.split(",")[1];
    setCroppedImage(cleanedUrl);
  };

  const handleBannerUpload = (e) => {
    e.preventDefault();
    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else {
      files = e.target.files;
    }
    const reader = new FileReader();
    reader.onload = () => {
      setImage(reader.result);
    };
    reader.readAsDataURL(files[0]);
  };
  const handleUpdateBanner = (e) => {
    e.preventDefault();
    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else {
      files = e.target.files;
    }
    const reader = new FileReader();
    reader.onload = () => {
      setBannerUpdate(reader.result);
    };
    reader.readAsDataURL(files[0]);
  };
  const handleImageUpload = (e) => {
    e.preventDefault();
    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else {
      files = e.target.files;
    }
    const reader = new FileReader();
    reader.onload = () => {
      setProfileImage(reader.result);
    };
    reader.readAsDataURL(files[0]);
  };
  const handleCancel = () => {
    setProfileImage(null); // Clear the state
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Reset the file input field
    }
  };

  return (
    <div style={{ flex: "1" }}>
      <div className="container">
        <div className="profile_section">
          <div className="row">
            <div className="col-lg-12 col-12">
              <div className="Cus_shadow newCus_shadow">
                <div>
                  <div className="e-profile">
                    <div className="Profile-image-flex-containe">
                      <div className="profile_img_flex_section">
                        {profileImage ? (
                          <div style={{ width: "100%" }}>
                            <Cropper
                              className="cropper_value"
                              src={profileImage}
                              style={{ height: 100 }}
                              aspectRatio={100 / 100}
                              guides={false}
                              crop={onProfileCrop}
                              initialAspectRatio={100 / 100}
                              ref={cropperProfileRef}
                              responsive={true}
                              autoCropArea={1}
                              background={false} // Hide the background
                            />
                          </div>
                        ) : (
                          <img
                            className="Profile-section-use-img"
                            src={imageUrl || FetchGoogleImage}
                            alt="Default Image"
                            layout="intrinsic"
                            onError={(e) => {
                              e.target.onerror = null; // Prevent infinite loop
                              e.target.src = "/Images/unisexImage.jpeg";
                            }}
                          />
                        )}
                      </div>
                      <div className="text-sm-left mb-sm-0">
                        <h4 className="pt-sm-2 pb-1 mb-0 text-nowrap ps-2">
                          {formData.name}
                        </h4>
                        <div className="col-lg-9 col-6"></div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="choose-banner-Image-container">
                        {/* <label> Choose Banner Images</label> */}
                        <input
                          className="form-control custom-file-input"
                          multiple=""
                          accept="image/png, image/jpeg, image/gif"
                          id="inputFile"
                          type="file"
                          onChange={handleImageUpload}
                          ref={profileImageRed}
                        />
                      </div>
                      {profileImage ? (
                        <div className="col-lg-4 mt-1">
                          {loading === "updateImage" ? (
                            <div className="d-flex gap-5">
                              <button
                                type="button"
                                className="btn view-data-btn"
                              >
                                <ClipLoader loading size={15} />
                              </button>
                              <button
                                type="button"
                                className="btn btn-secondary view-data-btn-cancle"
                                onClick={() => {
                                  document.getElementById("inputFile").value =
                                    "";
                                }}
                              >
                                Cancel
                              </button>
                            </div>
                          ) : (
                            <>
                              <button
                                type="button"
                                className="btn view-data-btn"
                                onClick={() => UpdateUserProfile("updateImage")}
                              >
                                Update Image
                              </button>
                              <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() => {
                                  document.getElementById("inputFile").value =
                                    "";
                                  handleCancel();
                                }}
                              >
                                Cancel
                              </button>
                            </>
                          )}
                        </div>
                      ) : null}
                    </div>

                    <hr />
                    <div className="tab-content pt-3">
                      <div className="tab-pane active">
                        <form className="form" novalidate="">
                          <div className="row">
                            <div className="col-lg-3">
                              <div className="form-group">
                                <label>Full Name</label>
                                <input
                                  className="form-control"
                                  type="text"
                                  name="name"
                                  placeholder="0"
                                  disabled
                                  value={formData?.name}
                                  onChange={(e) =>
                                    setFormData({
                                      ...formData,
                                      name: e?.target?.value,
                                    })
                                  }
                                />
                              </div>
                            </div>

                            <div className="col-lg-3">
                              <div className="form-group">
                                <label>Email</label>
                                <input
                                  className="form-control"
                                  type="text"
                                  placeholder="user@example.com"
                                  disabled
                                  value={formData?.email}
                                  onChange={(e) =>
                                    setFormData({
                                      ...formData,
                                      email: e?.target?.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                            {/* <div className="col-lg-3">
                              <div className="form-group">
                                <label>Address</label>
                                <input
                                  className="form-control"
                                  type="text"
                                  placeholder="Your Address"
                                  disabled={!editData}
                                  value={formData?.address}
                                  onChange={(e) =>
                                    setFormData({
                                      ...formData,
                                      address: e?.target?.value,
                                    })
                                  }
                                />
                              </div>
                            </div> */}
                            <div className="col-lg-3">
                              <div className="form-group">
                                <label>
                                  Phone No (use for money transfer )
                                </label>
                                <input
                                  className="form-control"
                                  type="tel"
                                  placeholder="Your Phone Number"
                                  disabled={!editData}
                                  value={formData?.phoneNo}
                                  onChange={(e) =>
                                    setFormData({
                                      ...formData,
                                      phoneNo: e?.target?.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                            {profileData?.IsInBusiness ? (
                              <>
                                <div className="col-lg-3">
                                  <div className="form-group">
                                    <label>Business Full Name</label>
                                    <input
                                      className="form-control"
                                      type="text"
                                      placeholder="Your Phone Number"
                                      disabled={!editData}
                                      value={formData?.businessName}
                                      onChange={(e) =>
                                        setFormData({
                                          ...formData,
                                          businessName: e?.target?.value,
                                        })
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-3">
                                  <div className="form-group">
                                    <label>Business GST No.</label>
                                    <input
                                      className="form-control"
                                      type="text"
                                      placeholder="Your Phone Number"
                                      disabled={!editData}
                                      value={formData?.gstno}
                                      onChange={(e) =>
                                        setFormData({
                                          ...formData,
                                          gstno: e?.target?.value,
                                        })
                                      }
                                    />
                                  </div>
                                </div>
                              </>
                            ) : null}
                            <div className="col-lg-12 edit_btn-spc">
                              <div className="form-group">
                                {editData ? (
                                  <>
                                    {loading === "updateprofile" ? (
                                      <>
                                        <button
                                          type="button"
                                          className="Save-profile-button"
                                        >
                                          {" "}
                                          <ClipLoader loading size={15} />
                                        </button>
                                        <button
                                          type="button"
                                          className="common_btn"
                                        >
                                          Cancel
                                        </button>
                                      </>
                                    ) : (
                                      <div className="d-flex gap-5">
                                        <button
                                          type="button"
                                          className="Save-profile-button btn view-data-btn"
                                          onClick={() => handleEditProfile()}
                                        >
                                          Save
                                        </button>
                                        <button
                                          type="button"
                                          className="common_btn btn btn-secondary"
                                          onClick={() => setEditData(false)}
                                        >
                                          Cancel
                                        </button>
                                      </div>
                                    )}
                                  </>
                                ) : (
                                  <button
                                    type="button"
                                    className="common_btn"
                                    onClick={() => setEditData(true)}
                                  >
                                    Edit Profile
                                  </button>
                                )}
                              </div>
                            </div>
                            {/* buisness code do not delete */}
                            {profileData?.IsInBusiness ? (
                              <>
                                <div className="mt-4">
                                  <h4 className="common_heading">
                                    Banner Details
                                  </h4>

                                  <div className="row">
                                    <div className="">
                                      <div className="product_top_section">
                                        <div className="row">
                                          {bannerImageData?.map((item) => {
                                            const image =
                                              item?.BannerUrl?.split('"');
                                            const imageUrl = `${Apiurl()}/${
                                              image?.[1]
                                            }`;
                                            return (
                                              <div className="col-lg-3 col-sm-4 col-12">
                                                <div className="pro_banner_btm_spc">
                                                  <img
                                                    src={imageUrl}
                                                    className="w-100"
                                                    onError={(e) => {
                                                      e.target.onerror = null;
                                                      e.target.src =
                                                        "/Images/banner-default.jpg";
                                                    }}
                                                  />
                                                  <div className="col-12 mt-2">
                                                    <button
                                                      type="button"
                                                      className="common_btn btn common_btn_pd view-data-btn"
                                                      onClick={() => {
                                                        setShowUpdate(true);
                                                        setClickedBannerData(
                                                          item
                                                        );
                                                      }}
                                                    >
                                                      Update Banner
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            );
                                          })}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </>
                            ) : null}
                            <AddressDetails
                              vendorBannerAnalytic={vendorBannerAnalytic}
                              updateIndex={updateIndex}
                              setUpdateIndex={setUpdateIndex}
                              setHideButton={setHideButton}
                              hideButton={hideButton}
                              setBannerUrl={setBannerUrl}
                              setShowSaveButton={setShowSaveButton}
                              showSaveButton={showSaveButton}
                              formData={formData}
                              Address={Address}
                              setAddress={setAddress}
                              handleAddAddress={handleAddAddress}
                              handleShow={handleShow}
                              handleClose={handleClose}
                              show={show}
                              DeliveryAddressList={DeliveryAddressList}
                              handleRemoveDeliveryAddress={
                                handleRemoveDeliveryAddress
                              }
                              handleEditaddress={handleEditaddress}
                              PrefiledData={PrefiledData}
                              UpdateDefaultDeliveryAddress={
                                UpdateDefaultDeliveryAddress
                              }
                            />
                            {!profileData?.IsInBusiness ? (
                              <div className="checkbox_banner">
                                <input
                                  type="checkbox"
                                  id="banner2"
                                  onChange={(e) =>
                                    setBuisnessCheck(e?.target?.checked)
                                  }
                                  checked={buisnessCheck}
                                />
                                <label for="banner2">
                                  If you want to become a Affiliate Partner
                                </label>
                              </div>
                            ) : null}
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* vendor code */}
        {profileData?.IsInBusiness ? (
          <>
            <div className="col-lg-12 col-12 mb-3">
              <h4 className="mb-3">Upload New Banner</h4>
              <div className="Cus_shadow">
                <div>
                  <div className="e-profile">
                    <div className="tab-content">
                      <div className="tab-pane active">
                        <div className="row">
                          <div className="col-lg-4">
                            <div className="form-group">
                              <form id="imageFormz">
                                <input
                                  className="form-control custom-file-input"
                                  multiple=""
                                  accept="image/png, image/jpeg, image/gif"
                                  id="inputFile"
                                  type="file"
                                  onChange={handleBannerUpload}
                                  ref={fileBannerRef}
                                />
                              </form>
                            </div>
                          </div>

                          {image ? (
                            <Cropper
                              src={image}
                              style={{ height: 400, width: "100%" }}
                              aspectRatio={1920 / 400}
                              guides={false}
                              crop={onCrop}
                              initialAspectRatio={160 / 900}
                              ref={cropperRef}
                              responsive={true}
                              autoCropArea={1}
                              background={false} // Hide the background
                            />
                          ) : (
                            <div className="col-lg-12">
                              <div className="form-group vendor_bnr_sec">
                                <div>
                                  <img
                                    src="/Images/banner-default.jpg"
                                    className="vendor_banner_show"
                                    alt="Uploaded Image"
                                  />
                                  <br />
                                </div>
                              </div>
                            </div>
                          )}
                          {image && (
                            <div className="col-lg-12 edit_btn-spc">
                              {loading === "bannerAdd" ? (
                                <ClipLoader loading size={15} />
                              ) : (
                                <button
                                  className="common_btn"
                                  type="button"
                                  onClick={BannerAdd}
                                >
                                  Upload New Banner
                                </button>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            {buisnessCheck ? (
              <>
                <div className="col-lg-12 col-12 mt-4 mb-3">
                  <form>
                    <h4 className="mb-3  Business-Profile-heading">
                      Business Profile Information
                    </h4>
                    <div className="Cus_shadow newCus_shadow">
                      {profileData?.RequestSubmited == true &&
                      profileData.Status == "Pending" ? (
                        <>
                          <div>
                            <p>
                              Your Request is Recieved and{" "}
                              <strong>{profileData.Status}</strong>{" "}
                            </p>
                            <p>
                              Your Request Token is{" "}
                              <strong>{profileData?.RequestNo}</strong>
                            </p>
                            <p>Wait for 48 Hour's until approval.</p>
                          </div>
                        </>
                      ) : profileData.Status == "Rejected" ? (
                        <>
                          <div>
                            <p>
                              Your Request is Recieved and{" "}
                              <strong>{profileData.Status}</strong>{" "}
                            </p>
                            <p>
                              Your Request Token is{" "}
                              <strong>{profileData?.RequestNo}</strong>
                            </p>
                          </div>
                        </>
                      ) : profileData.RequestSubmited == null ||
                        profileData.RequestSubmited == false ? (
                        <>
                          <div className="e-profile">
                            <div className="tab-content">
                              <div className="tab-pane active">
                                <div className="row">
                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <label>Business Full Name</label>
                                      <input
                                        className="form-control"
                                        type="text"
                                        name="name"
                                        placeholder="Name"
                                        value={businessDetail.BusinessName}
                                        onChange={(e) =>
                                          setBusinessDetail({
                                            ...businessDetail,
                                            BusinessName: e?.target?.value,
                                          })
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <label> Business GST No.</label>
                                      <input
                                        className="form-control"
                                        type="text"
                                        minlength="15"
                                        maxlength="15"
                                        placeholder="22AAAAA0000A1Z5"
                                        value={businessDetail.BusinessGSTNo}
                                        onChange={(e) =>
                                          setBusinessDetail({
                                            ...businessDetail,
                                            BusinessGSTNo: e?.target?.value,
                                          })
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <label
                                        className="Select-banner-image"
                                        for="image-upload-cover"
                                      >
                                        {" "}
                                        Select Banner Image{" "}
                                        <span className="Profile-screen-image-uploder">
                                          ( 1920 * 400 ) *
                                        </span>{" "}
                                      </label>
                                      <input
                                        className="form-control custom-file-input"
                                        multiple=""
                                        id="image-upload-cover"
                                        accept="image/png, image/jpeg, image/gif"
                                        type="file"
                                        onChange={handleBannerUpload}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-12">
                                    <div className="form-group vendor_bnr_sec">
                                      <div className="cropper-container">
                                        {image && (
                                          <Cropper
                                            src={image}
                                            style={{
                                              height: 400,
                                              width: "100%",
                                            }}
                                            aspectRatio={1920 / 400}
                                            guides={false}
                                            crop={onCrop}
                                            initialAspectRatio={160 / 900}
                                            ref={cropperRef}
                                            responsive={true}
                                            autoCropArea={1}
                                            background={false}
                                          />
                                        )}
                                        <img
                                          className="vendor_banner_show"
                                          src="/Images/banner-default.jpg"
                                          alt="Default Image"
                                          layout="intrinsic"
                                        />
                                        <br />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-lg-12 edit_btn-spc">
                                    {loading == "business" ? (
                                      <button
                                        className="common_btn"
                                        type="button"
                                      >
                                        <ClipLoader loading size={15} />
                                      </button>
                                    ) : (
                                      <button
                                        className="common_btn"
                                        type="button"
                                        onClick={() => handleMoveToBusiness()}
                                      >
                                        Apply For Affiliate Partner
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : null}
                      <div></div>
                    </div>
                  </form>
                </div>
              </>
            ) : null}
          </>
        )}

        {/*  */}
        <Modal
          backdrop="static"
          className="image-modal-update-banner"
          show={showUpdate}
          onHide={handleCloseBanner}
          animation={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Update Banner</Modal.Title>
          </Modal.Header>
          <Modal.Body className="popup_body_scroll">
            <div className="col-12">
              <div>
                <img
                  src={`${Apiurl()}/${clickedBannerData?.BannerUrl?.replace(
                    /"/g,
                    ""
                  )}`}
                  //   src={${Apiurl()}/${clickedBannerData?.BannerUrl?.split('"')?.[1]}}
                  className="w-100 mb-2"
                />
              </div>
              <form id="bannerFormz" data-gtm-form-interact-id="0">
                <input
                  className="form-control custom-file-input"
                  multiple=""
                  accept="image/png, image/jpeg, image/gif"
                  id="inputFile"
                  type="file"
                  onChange={handleUpdateBanner}
                />
              </form>
              <div className="mt-2">
                <img id="Updatedbanner" className="w-100" />
              </div>
            </div>
            <div className="col-lg-12">
              <div className="form-group vendor_bnr_sec">
                <div className="cropper-container">
                  {bannerUpdate && (
                    <Cropper
                      src={bannerUpdate}
                      style={{ height: 400, width: "100%" }}
                      aspectRatio={1920 / 400}
                      guides={false}
                      crop={onUpdateBannerCrop}
                      initialAspectRatio={160 / 900}
                      ref={cropperRefBanner}
                      responsive={true}
                      autoCropArea={1}
                      background={false}
                    />
                  )}
                  <img
                    className="vendor_banner_show"
                    src="/Images/banner-default.jpg"
                    alt="Default Image"
                    layout="intrinsic"
                  />
                  <br />
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="common_btn btn-secondary"
              data-dismiss="modal"
              onClick={handleCloseBanner}
            >
              Close
            </button>
            {loading=="bannerUpdate"?
              <button
              type="button"
              className="common_btn view-data-btn"
            >
               <ClipLoader loading size={15} />
            </button>
          :
          <button
          type="button"
          className="common_btn view-data-btn"
          onClick={handleUpdateBannerImage}
        >
          Save changes
        </button>
          }
          
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};
export default ProfileComponent;
